var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "99F38D02-1FFD-43E3-B209-EBF942AFF167") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-Center--New-Message",
    transform: "translate(-1334.000000, -655.000000)",
    fill: "#3A96DC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1344.64215,655.627759 L1352.74973,673.436653 C1352.77834,673.499484 1352.75059,673.573607 1352.68776,673.602211 C1352.66876,673.610859 1352.6479,673.614613 1352.62708,673.613129 L1345.09141,673.076205 L1345.09141,673.076205 L1344.30085,664.253077 L1343.33656,673.076205 L1335.97498,673.61276 C1335.90613,673.617778 1335.84624,673.56603 1335.84122,673.497177 C1335.8397,673.476291 1335.84345,673.455357 1335.85213,673.436298 L1343.95955,655.627759 C1344.04537,655.439266 1344.26773,655.356027 1344.45623,655.441839 C1344.53861,655.479343 1344.60464,655.545379 1344.64215,655.627759 Z",
    id: "Triangle",
    transform: "translate(1344.300849, 664.253077) rotate(90.000000) translate(-1344.300849, -664.253077) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/Triangle.5670dac6c40eb13b62f6ef7dcfc81311.svg";
export { ForwardRef as ReactComponent };